module.exports = __webpack_public_path__ + "static/media/ltc-logo.73a796b0.png";